import { render, staticRenderFns } from "./SdsBottomSheet.vue?vue&type=template&id=07b976de&scoped=true"
import script from "./SdsBottomSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsBottomSheet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsBottomSheet.vue?vue&type=style&index=0&id=07b976de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b976de",
  null
  
)

export default component.exports